import { observable, action, runInAction } from 'mobx';

import { StoreExt } from '@utils/reactExt';
import { RECORD_CUSTOM_EVENT, VERIFY_FAILED, VERIFY_STATE } from '@constants/index';
import { queryURL } from '@utils/index';

export class RecordStore extends StoreExt {
    @observable
    txrWebInstance: TxrWeb | undefined = undefined;

    @observable
    uploadErrorCount: number = 0;

    @action
    async startRecord(
        bizKey: string,
        pageTitle?: string,
        forceStart: boolean = false,
        tenantId?: string
    ): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            try {
                // 6437a1c17058ae169cb2bfe2 兴邦租户id
                // process.env.NODE_ENV === 'development' ? process.env.RECORD_BASE_URL : window.location.origin
                this.txrWebInstance = new TxrWeb({
                    privateKey: process.env.RECORD_PRIVATE_KEY,
                    serverURL: process.env.RECORD_BASE_URL,
                    bizKey,
                    pageTitle: pageTitle || document.title,
                    version: process.env.APP_VERSION,
                    forceStart,
                    timeout: 15000,
                    onUploadStatus: status => {
                        if (!status) {
                            runInAction(() => {
                                this.uploadErrorCount += 1;
                            });
                        } else {
                            runInAction(() => {
                                this.uploadErrorCount = 0;
                            });
                        }

                        if (this.uploadErrorCount > 5) {
                            this.stopRecord();
                            this.$toast.show({
                                icon: 'fail',
                                content: '页面录制异常',
                                afterClose: async () => {
                                    try {
                                        await this.$api.task.verifyFailed({
                                            taskState: VERIFY_FAILED.FAILED_202,
                                            message: '回溯上传数据连续失败'
                                        });
                                    } catch (error) {
                                    } finally {
                                        const failUrl =
                                            queryURL('failUrl') && queryURL('failUrl') !== ''
                                                ? queryURL('failUrl')
                                                : queryURL('pageTitle')
                                                ? `${window.origin}/result/failed/?pageTitle=${encodeURIComponent(
                                                      queryURL('pageTitle')
                                                  )}`
                                                : `${window.origin}/result/failed`;
                                        window.location.href = failUrl;
                                    }
                                }
                            });
                        }
                    },
                    success: (bizId: string) => {
                        this.txrWebInstance?.updateBiz({ bizId, insNo: bizKey });
                        resolve();
                    },
                    error: (err: any) => {
                        this.$api.task
                            // @ts-ignore
                            .verifyFailed({ taskState: VERIFY_FAILED.FAILED_202, message: '回溯初始化失败' })
                            .catch(err => {})
                            .finally(() => {
                                reject({
                                    error: {
                                        errCode: VERIFY_STATE.NO_PASS,
                                        taskState: VERIFY_FAILED.FAILED_307,
                                        message: err
                                    }
                                });
                            });
                    }
                });
            } catch (error) {
                this.$api.task
                    // @ts-ignore
                    .verifyFailed({ taskState: VERIFY_FAILED.FAILED_202, message: '回溯初始化失败' })
                    .catch(err => {})
                    .finally(() => {
                        reject({
                            error: {
                                errCode: VERIFY_STATE.NO_PASS,
                                taskState: VERIFY_FAILED.FAILED_307,
                                message: error
                            }
                        });
                    });
            }
        });
    }

    @action
    recordPlayVideoEvent(ele: string) {
        const target = document.getElementById(ele);
        const mirror = this.txrWebInstance?.getMirror();
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.VIDEO_PLAY_EVENT, {
            eleId: ele,
            txrSnId: mirror?.getId(target)
        });
    }

    @action
    recordPauseVideoEvent() {
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.VIDEO_PAUSE_EVENT, {});
    }

    @action
    startRecordStream() {
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.START_RECORD_STREAM, {});
    }

    @action
    recordPlayAudioEvent() {
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.AUDIO_PLAY_EVENT, {});
    }

    @action
    recordPauseAudioEvent() {
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.AUDIO_PAUSE_EVENT, {});
    }

    @action
    startRecordAudio() {
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.START_RECORD_AUDIO, {});
    }

    @action
    stopRecordAudio() {
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.STOP_RECORD_AUDIO, {});
    }

    @action
    recordAudioVolume(volume: number) {
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.RECORD_AUDIO_VOLUME_CHANGE, { volume });
    }

    @action
    verifySuccess() {
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.VERIFY_SUCCESS, {});
    }

    @action
    verifyFailed() {
        this.txrWebInstance?.addCustomEvent(RECORD_CUSTOM_EVENT.VERIFY_FAILED, {});
    }

    @action
    stopRecord() {
        this.txrWebInstance?.stopRecord();
    }
}

export default new RecordStore();
